import { FC } from 'react';

const ExitSlipModalBodyNoDataYet: FC = () => {
  return (
    <div className="flex p-4 flex-column align-items-center" style={{ backgroundColor: '#FAFAFA', height: '100vh' }}>
      <span className="pi pi-folder-open" style={{ fontSize: '2rem', color: '#9C9B9B' }}></span>
      <h3 className="font-bold">Select a Class and a Roadmap</h3>
      <h4 className="text-center">
        We started you off with your current class and its roadmap — change either one if you need to. Unit is optional.
      </h4>
    </div>
  );
};

export default ExitSlipModalBodyNoDataYet;
